<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Deposit List</h5>

      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Time Range</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Recipient</label>
          <input [(ngModel)]="Filter_Price_Giver" name="Filter_Price_Giver" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Description</label>
          <input [(ngModel)]="Filter_Dsc" name="Filter_Dsc" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!InProccessing" type="button"
            (click)="ReadData_Funds(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <button *ngIf="!InProccessing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <label style="font-weight: bolder;">Grand Total : {{DataList_Funds_Charge_Price|number}}</label>
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Deposited Amount (IRR)</th>
              <th>Deposit Date</th>
              <th>Description</th>
              <th>Recipient</th>
              <th>Created By</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds_Charge
            |filter:Filter_Price_Giver:'price_user'
            |filter:Filter_Dsc:'dsc'
            | paginate
                    : {
                        id: 'DataList_UserTable_Charge',
                        itemsPerPage: 10,
                        currentPage: page_Charge,
                        totalItems: (DataList_Funds_Charge
                        |filter:Filter_Price_Giver:'price_user'
                        |filter:Filter_Dsc:'dsc').length
                      }
            ">
              <td>{{DataList_Funds_Charge.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.price | number}}</td>
              <td>{{item.price_date}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.price_user}}</td>
              <td>{{item.username}}</td>
              <td>{{item.subdate}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <pagination-controls id="DataList_UserTable_Charge" nextLabel="Next" previousLabel="Previous"
        (pageChange)="page_Charge = $event"></pagination-controls>
    </div>
  </div>
</div>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>ID</th>
      <th>Deposited Amount (IRR)</th>
      <th>Deposit Date</th>
      <th>Description</th>
      <th>Recipient</th>
      <th>Created By</th>
      <th>Date</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Funds_Charge
    |filter:Filter_Price_Giver:'price_user'
    |filter:Filter_Dsc:'dsc'">
      <td>{{item.code}}</td>
      <td>{{item.price | number}}</td>
      <td>{{item.price_date}}</td>
      <td>{{item.dsc}}</td>
      <td>{{item.price_user}}</td>
      <td>{{item.username}}</td>
      <td>{{item.subdate}}</td>
    </tr>
  </tbody>
</table>
